import {createSvgIcon} from '../create-svg-icon';

export const ArrowRightAltIcon = createSvgIcon(
  <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
, 'ArrowRightAltOutlined');
